import { Flame } from "lucide-react";

export const hotGlow = (p) => (p?.hot ? "pp-hot-glow" : "");

export const HotBadge = ({ p, className = "", testId }) => (p?.hot ? (
  <span className={`pp-hot-badge ${className}`} data-testid={testId || `hot-badge-${p.slug}`}><Flame size={11} strokeWidth={2.6} aria-hidden="true" />{p.hot_label === "Popular" ? "Popular" : "HOT"}</span>
) : null);
